import { Box, VStack, HStack, Text, Heading, Button } from '@chakra-ui/react';

export interface WelcomeStepProps {
  onContinue: () => void;
}

export function WelcomeStep({ onContinue }: WelcomeStepProps) {
  return (
    <VStack
      flex={1}
      p={6}
      justify="center"
      align="center"
      gap={6}
      bg="gray.50"
      data-testid="wizard-welcome-step"
    >
      <Box
        w="120px"
        h="120px"
        borderRadius="24px"
        bg="brand.50"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={4}
      >
        <Text fontSize="4xl" color="brand.500">🎵</Text>
      </Box>

      <VStack align="center" gap={3}>
        <Heading as="h1" size="2xl" fontWeight="bold" color="gray.800" textAlign="center">
          Welcome to Streamko
        </Heading>
        <Text fontSize="lg" color="gray.500" textAlign="center" maxW="400px">
          Let's set up your business audio streaming in about 2 minutes.
        </Text>
      </VStack>

      <VStack
        gap={3}
        mt={4}
        p={4}
        bg="gray.50"
        borderRadius="md"
        w="100%"
        maxW="400px"
      >
        <Text fontSize="md" fontWeight="600" color="gray.800">
          Quick setup includes:
        </Text>
        {['Create your account', 'Set up your first location', 'Choose your music preferences', 'Start streaming instantly'].map((item) => (
          <HStack key={item} gap={3} align="center">
            <Text color="green.500">✓</Text>
            <Text fontSize="sm" color="gray.500">{item}</Text>
          </HStack>
        ))}
      </VStack>

      <Button
        size="lg"
        bg="brand.500"
        color="white"
        fontWeight="bold"
        mt={6}
        w="100%"
        maxW="400px"
        onClick={onContinue}
        data-testid="wizard-get-started-button"
        _hover={{ bg: 'brand.600' }}
      >
        Get Started
      </Button>

      <Text fontSize="xs" color="gray.500" mt={2}>
        No credit card required for free trial
      </Text>
    </VStack>
  );
}

export default WelcomeStep;
